/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* CWD: reapply Sami pricing after Warehouse replaces variant/price blocks. */
(() => {
  if (window.cwdSamiVariantBridge) return;
  window.cwdSamiVariantBridge = true;
  const pending = new WeakMap();
  const extendVariantSelectors = () => {
    const selectors = window.Samita?.Wholesale?.settings?.selectors?.product;
    if (!selectors) return;
    for (const key of ['variantSelector', 'productVariant']) {
      const items = (selectors[key] || '').split(',').map(s => s.trim()).filter(Boolean);
      if (!items.includes('input[name="id"]')) items.push('input[name="id"]');
      selectors[key] = items.join(', ');
    }
  };
  document.addEventListener('samitaWS.scripts.loaded', extendVariantSelectors);
  extendVariantSelectors();
  document.addEventListener('variant:changed', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('product-rerender')) return;
    clearTimeout(pending.get(form));
    pending.set(form, setTimeout(async () => {
      pending.delete(form);
      if (!form.isConnected) return;
      const app = window.Samita?.Wholesale;
      const product = app?.product;
      const handler = app?.HandleProduct;
      const root = form.closest('[samitaWS-element][data-samitaWS-type="product"]');
      const input = form.querySelector('input[name="id"], select[name="id"]');
      const variantId = input?.value;
      if (!root || !product || !handler?.buildWholesaleWidget ||
          !product.variants?.some(variant => String(variant.id) === variantId)) return;
      extendVariantSelectors();
      root.setAttribute('p-variant-id', variantId);
      try {
        await handler.buildWholesaleWidget({
          productEl: root, productJson: product,
          pageType: 'product', variant_id: variantId
        });
      } catch (error) {
        console.warn('CWD Sami variant pricing refresh failed', error);
      }
    }, 100));
  });
})();


(() => {
  const pending = new Set();
  const selector = '[data-cwd-cart-line]';
  const checkoutSelector = '[name="checkout"], .cart-recap__checkout, .samitaWS-clone-checkout-button, a[href="/checkout"], a[href^="/checkout?"]';
  const scopeFor = el => el.closest('#mini-cart, [data-section-type="cart"]');
  const message = (el, key) => el.dataset[`cwdStock${key}`] || el.dataset[`cwdCart${key}`];
  const alertAt = (parent, before, text, attribute) => {
    const alert = document.createElement('div');
    alert.className = 'alert alert--error';
    alert.setAttribute(attribute, '');
    alert.setAttribute('role', 'alert');
    alert.textContent = text;
    before ? before.before(alert) : parent.prepend(alert);
    return alert;
  };
  const productError = (form, text) => {
    form.querySelector('[data-cwd-stock-error]')?.remove();
    alertAt(form, form.querySelector('.product-form__payment-container'), text, 'data-cwd-stock-error');
  };
  const readSnapshot = async (path, variant) => {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) throw Error('origin');
    url.searchParams.set('section_id', 'cwd-stock-status');
    url.searchParams.set('_cwd_check', String(Date.now()));
    if (variant) url.searchParams.set('variant', variant);
    const response = await fetch(url.href, {
      credentials: 'same-origin', cache: 'no-store',
      headers: {Accept: 'text/html'}, signal: AbortSignal.timeout(15000)
    });
    if (!response.ok) throw Error('stock');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = doc.querySelector('[data-cwd-stock-snapshot]');
    if (!node) throw Error('stock');
    const data = JSON.parse(node.getAttribute('data-cwd-stock-snapshot'));
    if (data.version !== 1 || !Array.isArray(data.items) ||
        !data.items.every(item => typeof item.key === 'string' && typeof item.variant === 'string' &&
          Number.isInteger(item.quantity) && item.quantity > 0 && Number.isInteger(item.stock) && typeof item.managed === 'boolean') ||
        data.items.reduce((sum, item) => sum + item.quantity, 0) !== data.itemCount) throw Error('stock');
    return data;
  };
  window.cwdReserveCartAddition = async form => {
    const container = form?.querySelector('[data-cwd-stock-variant]');
    if (!container) return null;
    const data = container.dataset;
    const initial = new FormData(form);
    const id = String(initial.get('id'));
    const quantity = Number(initial.get('quantity') || 1);
    form.querySelector('[data-cwd-stock-error]')?.remove();
    if (id !== data.cwdStockVariant || !Number.isInteger(quantity) || quantity < 1) {
      productError(form, message(container, 'Retry'));
      return false;
    }
    if (pending.has(id)) { productError(form, message(container, 'Busy')); return false; }
    pending.add(id);
    const release = () => pending.delete(id);
    try {
      const snapshot = await readSnapshot(data.cwdStockUrl, id);
      const variant = snapshot.product;
      const current = new FormData(form);
      if (!form.isConnected || String(current.get('id')) !== id || Number(current.get('quantity') || 1) !== quantity ||
          !variant || variant.variant !== id || !Number.isInteger(variant.stock) || typeof variant.managed !== 'boolean') throw Error('variant');
      const displayedManaged = data.cwdStockManaged === 'true';
      if (displayedManaged !== variant.managed || (variant.managed && (Number(data.cwdStockQuantity) > 0) !== (variant.stock > 0))) {
        productError(form, message(container, 'Changed'));
        release(); return false;
      }
      const intent = !variant.managed ? 'untracked' : variant.stock > 0 ? 'stock' : 'backorder';
      const matching = snapshot.items.filter(item => item.variant === id);
      if (variant.managed && variant.stock > 0 && matching.reduce((sum, item) => sum + item.quantity, 0) + quantity > variant.stock) {
        productError(form, data.cwdStockExceeded.replace('__stock__', variant.stock).replace('__cart__', matching.reduce((sum, item) => sum + item.quantity, 0)));
        release(); return false;
      }
      let property = form.querySelector('[name="properties[_cwd_stock_intent]"]');
      if (!property) {
        property = document.createElement('input'); property.type = 'hidden';
        property.name = 'properties[_cwd_stock_intent]'; container.append(property);
      }
      property.value = intent;
      return release;
    } catch {
      productError(form, message(container, 'Retry'));
      release(); return false;
    }
  };
  const collectLines = scope => {
    const lines = new Map();
    for (const el of scope.querySelectorAll(selector)) {
      const data = el.dataset;
      const value = Number(el.querySelector('input').value);
      const changed = value !== Number(data.cwdCartCurrent);
      const previous = lines.get(data.cwdCartLine);
      if (!previous || (changed && (!previous.changed || value > previous.value))) lines.set(data.cwdCartLine, {el, data, value, changed});
    }
    return [...lines.values()];
  };
  const localFailures = scope => {
    const lines = collectLines(scope), totals = new Map();
    for (const {data, value} of lines) totals.set(data.cwdCartVariant, (totals.get(data.cwdCartVariant) || 0) + value);
    return lines.filter(({data, value}) => data.cwdCartManaged === 'true' &&
      (Number(data.cwdCartStock) > 0 || data.cwdCartIntent === 'stock') &&
      (!Number.isInteger(value) || value < 0 || totals.get(data.cwdCartVariant) > Math.max(0, Number(data.cwdCartStock))));
  };
  const clearErrors = scope => {
    scope.querySelectorAll('[data-cwd-cart-error]').forEach(el => el.remove());
    scope.querySelectorAll('[aria-invalid="true"]').forEach(el => el.removeAttribute('aria-invalid'));
  };
  const showFailures = (scope, failures, text) => {
    clearErrors(scope);
    const variants = new Set(failures.map(line => line.data.cwdCartVariant));
    for (const el of scope.querySelectorAll(selector)) if (variants.has(el.dataset.cwdCartVariant)) {
      el.querySelector('input').setAttribute('aria-invalid', 'true');
      const alert = alertAt(scope, null, text || el.dataset.cwdCartExceeded.replaceAll('__stock__', Math.max(0, Number(el.dataset.cwdCartStock))), 'data-cwd-cart-error');
      el.after(alert);
    }
  };
  const globalError = (scope, text) => { clearErrors(scope); alertAt(scope, scope.querySelector('.cart-recap__checkout, .mini-cart__recap'), text, 'data-cwd-cart-error'); };
  const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
  let checking = false;
  const approvedClicks = new WeakSet(), approvedForms = new WeakSet();
  const checkCheckout = async (scope, resume) => {
    if (checking || pending.size) { globalError(scope, message(scope, 'Busy')); return; }
    const local = localFailures(scope);
    if (local.length) { showFailures(scope, local); return; }
    checking = true;
    scope.setAttribute('aria-busy', 'true');
    const controls = [...scope.querySelectorAll(`${selector} input, ${selector} button`)];
    const restore = controls.map(el => ({el, disabled:el.disabled, readOnly:el.readOnly}));
    controls.forEach(el => { if (el.tagName === 'INPUT') el.readOnly = true; else el.disabled = true; });
    const finish = () => {
      restore.forEach(({el, disabled, readOnly}) => {el.disabled = disabled; if (el.tagName === 'INPUT') el.readOnly = readOnly;});
      scope.removeAttribute('aria-busy'); checking = false;
    };
    try {
      const lines = collectLines(scope), snapshot = await readSnapshot(window.routes.cartUrl);
      if (snapshot.items.length !== lines.length || snapshot.items.some(item => !lines.some(line => line.data.cwdCartKey === item.key && line.value === item.quantity))) {
        globalError(scope, message(scope, 'Refresh')); finish(); return;
      }
      const totals = new Map();
      snapshot.items.forEach(item => totals.set(item.variant, (totals.get(item.variant) || 0) + item.quantity));
      const failures = [];
      let stockCart = false, boCart = false;
      for (const item of snapshot.items) {
        const line = lines.find(line => line.data.cwdCartKey === item.key);
        const intent = item.intent || line.data.cwdCartIntent;
        for (const el of scope.querySelectorAll(selector)) if (el.dataset.cwdCartKey === item.key) el.dataset.cwdCartStock = String(item.stock);
        if (!item.managed) continue;
        if (intent === 'backorder') {
          boCart = true;
          if (item.stock > 0) failures.push(line);
        } else {
          stockCart = true;
          if (intent !== 'stock' || item.stock <= 0 || totals.get(item.variant) > item.stock) failures.push(line);
        }
      }
      if (failures.length) { showFailures(scope, failures, message(scope, 'Changed')); finish(); return; }
      if (stockCart && boCart) { globalError(scope, message(scope, 'Mixed')); finish(); return; }
      clearErrors(scope);
      finish();
      resume();
    } catch {
      globalError(scope, message(scope, 'Retry'));
      finish();
    }
  };
  for (const type of ['input', 'change']) window.addEventListener(type, event => {
    const el = event.target.closest(selector);
    if (!el || event.target.tagName !== 'INPUT') return;
    if (checking) { stop(event); return; }
    const scope = scopeFor(el), failures = localFailures(scope);
    showFailures(scope, failures);
    if (failures.length && type === 'change') stop(event);
  }, true);
  window.addEventListener('click', event => {
    const checkout = event.target.closest(checkoutSelector);
    if (checkout) {
      if (approvedClicks.has(checkout)) { approvedClicks.delete(checkout); return; }
      const scope = scopeFor(checkout); if (!scope) return;
      stop(event);
      checkCheckout(scope, () => {approvedClicks.add(checkout); checkout.click(); approvedClicks.delete(checkout);});
      return;
    }
    const control = event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');
    const el = control?.closest(selector);
    if (checking && event.target.closest('#mini-cart, [data-section-type="cart"]')) { stop(event); return; }
    if (!el) return;
    el.querySelector('input').value = control.getAttribute('data-quantity');
    const scope = scopeFor(el), failures = localFailures(scope);
    showFailures(scope, failures);
    if (failures.length) stop(event);
  }, true);
  window.addEventListener('submit', event => {
    const scope = scopeFor(event.target); if (!scope) return;
    if (approvedForms.has(event.target)) { approvedForms.delete(event.target); return; }
    const form = event.target, submitter = event.submitter;
    stop(event);
    checkCheckout(scope, () => {approvedForms.add(form); form.requestSubmit(submitter); approvedForms.delete(form);});
  }, true);
})();
